import { render, staticRenderFns } from "./VuesticChat.vue?vue&type=template&id=23121b6e&scoped=true"
import script from "./VuesticChat.vue?vue&type=script&lang=js"
export * from "./VuesticChat.vue?vue&type=script&lang=js"
import style0 from "./VuesticChat.vue?vue&type=style&index=0&id=23121b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23121b6e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-chat/VuesticChat.vue
// module id = Gu02
// module chunks = 41